<template>
	<inertia-head title="Expired Tracker" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Expired Tracker</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Expired Tracker
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<!-- <div class="row">
			<div class="col-lg-12">
				<div class="block block-rounded shadow mb-1">
					<div class="block-content">
						<form @submit.prevent="searchRecordBeforeExpired(0)">
							<div class="row">
								<div class="col-9 space-x-1 mb-4">
									<input v-model="email_b" type="text" id="email_b" name="email_b" class="form-control" placeholder="Enter Email Address" />
								</div>
								<div class="col space-x-1 mb-4">
									<button type="submit" class="btn btn-alt-primary">
										<i class="fa fa-search me-1"></i>Display
									</button>
									<button
										@click="searchRecordBeforeExpired(1)"
										type="button"
										class="btn btn-alt-secondary"
									>
										<i class="fa fa-retweet me-1"></i>Reset
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>

				<div class="block block-rounded">
					<div class="block-header border-bottom">
						<div class="block-title">Seven Day Before Expired List</div>
					</div>
					<div class="block-content block-content-full">
						<div class="table-responsive">
							<table class="table table-striped table-borderless table-vcenter">
								<thead class="border-bottom">
									<tr>
										<th>ACTION</th>
										<th>FOLLOW-UP STATUS</th>
										<th>TXN ID</th>
										<th>DATE CREATED</th>
										<th>FULLNAME</th>
										<th>MOBILE</th>
										<th>EXPIRY</th>
										<th>SUBSCRIPTION</th>
										<th>AMOUNT</th>
										<th>MOP</th>
										<th>STATUS</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(member,m_index) in sevendayBeforeExpired.data" :key="member.counter">
										<td nowrap="">
											<button @click="setMemberBefore(m_index)" type="button" class="btn btn-alt-primary btn-sm"><i class="fa fa-arrow-circle-up me-1" ></i> Follow up</button>
										</td>
										<td>
											{{member.follow_status}}
										</td>
										<td>{{ member.txnid }}</td>
										<td>{{ member.date_created }}</td>
										<td>
											{{ member.fullname }}
											<div class="fs-sm text-info">{{ member.username }}</div>
										</td>
										<td>{{ member.mobile }}</td>
										<td>{{ member.expiry }}</td>
										<td>
											{{ member.codetype }}
											<div>{{ member.subscription }}</div>
										</td>
										<td>{{ member.amount }}</td>
										<td>{{ member.mop }}</td>
										<td>{{ member.status }}</td>
									</tr>
									<tr v-if="sevendayBeforeExpired.data.length<=0">
										<td colspan="11">
											<p class="m-0 fw-bold h5 text-center text-danger">No Record Found</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<pagination :collections="sevendayBeforeExpired" />
					</div>
				</div>
			</div>
		</div> -->

		<div v-if="totalStatus.remain<=0" class="row mt-5">
			<div class="col-12 text-center">
				<button @click="claimExpiredMember" type="button" class="btn btn-lg btn-info">Claim 15 Expired Member</button>
			</div>
		</div>

		<div class="row mt-5">
			<div class="col-lg-12">
				<div class="block block-rounded shadow mb-1">
					<div class="block-content">
						<form @submit.prevent="searchRecord(0)">
							<div class="row">
								<div class="col-md-2">
									<div class="form-group mb-4">
										<flat-pickr
											v-model="date_start"
											id="date_start"
											class="form-select"
											placeholder="Select start date"
										/>
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group mb-4">
										<flat-pickr
											v-model="date_end"
											id="date_end"
											class="form-select"
											placeholder="Select end date"
										/>
									</div>
								</div>
								<div class="col space-x-1 mb-4">
									<input v-model="email" type="text" id="email" name="email" class="form-control" placeholder="Enter Email Address" />
								</div>
								<div class="col space-x-1 mb-4">
									<select v-model="filterby" class="form-select">
										<option selected value='ALL'>ALL RECORDS</option>
                                        <option value='pending'>Pending</option>
                                        <option value='will not renew'>Will not renew</option>
                                        <option value='will renew next time'>Will renew next time</option>
                                        <option value='call not answered'>Call not answered</option>
                                        <option value='number incorrect'>Number Incorrect</option>
                                        <option value='international number'>International Number</option>
                                        <option value='requested for callback'>Requested for callback</option>
                                        <option value='renewed'>Renewed</option>
                                        <option value='cs auto renewed'>CS Auto Renewed</option>
									</select>
								</div>
								<div class="col space-x-1 mb-4">
									<button type="submit" class="btn btn-alt-primary">
										<i class="fa fa-search me-1"></i>Display
									</button>
									<!-- <button
										@click="searchRecord(1)"
										type="button"
										class="btn btn-alt-secondary"
									>
										<i class="fa fa-retweet me-1"></i>Reset
									</button> -->
								</div>
							</div>
						</form>
					</div>
				</div>

				<div class="block block-rounded">
					<div class="block-header border-bottom">
						<h3 class="block-title">Expired List</h3>
					</div>
					<div class="block-content block-content-full">
						<p>
							<span class="badge bg-info me-1">Total Claimed: {{totalStatus.total_claimed}}</span>
							<span class="badge bg-danger me-1">Total Expired: {{totalStatus.total_expired}}</span>
							<span class="badge bg-warning me-1">Total Expiring: {{totalStatus.total_expiring}}</span>
							<span class="badge bg-success">Total Renewed: {{totalStatus.total_renewed}}</span>
						</p>
						<div class="table-responsive">
							<table class="table table-striped table-borderless table-vcenter fs-sm">
								<thead class="border-bottom">
									<tr>
										<th>ACTION</th>
										<th>MEMBER ID</th>
										<th>FOLLOW-UP STATUS</th>
										<th>MEMBERS INFO</th>
										<th>MOBILE</th>
										<th>EXPIRY</th>
										<th>MEMBERSHIP</th>
										<th>MEMBERSHIP STATUS</th>
										<th>MOP</th>
										<th>STATUS</th>
										<th>CREATED</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(member,m_index) in expiredMembers.data" :key="member.counter">
										<td nowrap="">
											<button @click="setMember(m_index)" type="button" class="btn btn-alt-primary btn-sm"><i class="fa fa-arrow-circle-up me-1" ></i> Follow up</button>
										</td>
										<td>{{member.counter}}</td>
										<td>{{member.follow_status}}</td>
										<td>
											<span>{{ member.fname }} {{ member.lname }}</span>
											<div class="text-info">{{ member.email }}</div>
										</td>
										<td>{{ member.mobile }}</td>
										<td nowrap="">{{ member.expiry }}</td>
										<td nowrap="">{{member.current_rank}}</td>
										<td nowrap="">{{member.member_status}}</td>
										<td>{{ member.mop }}</td>
										<td>{{ member.status }}</td>
										<td nowrap="">{{ member.date_created }}</td>
									</tr>
									<tr v-if="expiredMembers.data.length<=0">
										<td colspan="10">
											<p class="m-0 fw-bold h5 text-center text-danger">No Record Found</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<pagination :collections="expiredMembers" />
					</div>
				</div>
			</div>
		</div>

		<div class="row mt-5">
			<div class="col-lg-12">
				<div class="block block-rounded shadow mb-1">
					<div class="block-content">
						<form @submit.prevent="searchFollowUpRecord(0)">
							<div class="row">
								<div class="col-md-3">
									<div class="form-group mb-4">
										<flat-pickr
											v-model="f_date_start"
											id="f_date_start"
											class="form-select"
											placeholder="Select start date"
										/>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group mb-4">
										<flat-pickr
											v-model="f_date_end"
											id="f_date_end"
											class="form-select"
											placeholder="Select end date"
										/>
									</div>
								</div>
								<div class="col space-x-1 mb-4">
									<select v-model="followup_status" id="followup_status" name="followup_status" class="form-control">
										<option value=''>All Status</option>
										<option value='will not renew'>Will not renew</option>
                                        <option value='will renew next time'>Will renew next time</option>
                                        <option value='no response'>No Response</option>
									</select>
								</div>
								<div class="col space-x-1 mb-4">
									<button type="submit" class="btn btn-alt-primary">
										<i class="fa fa-search me-1"></i>Display
									</button>
									<button
										@click="searchFollowUpRecord(1)"
										type="button"
										class="btn btn-alt-secondary"
									>
										<i class="fa fa-retweet me-1"></i>Reset
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
				<div class="block block-rounded">
					<div class="block-header border-bottom">
						<h3 class="block-title">Follow-Up Record List</h3>
					</div>
					<div class="block-content block-content-full">
						<div class="table-responsive">
							<table class="table table-striped table-borderless table-vcenter fs-sm">
								<thead class="border-bottom">
									<tr>
										<th>MEMBER ID</th>
										<th>MEMBERS INFO</th>
										<th>MOBILE</th>
										<th>MEMBERSHIP</th>
										<th>FOLLOW UP BY</th>
										<th>DATE</th>
										<th>REMARKS</th>
										<th>STATUS</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="member in followUp.data" :key="member.member_id">
										<td>{{ member.member_id }}</td>
										<td>
											<span>{{ member.fname }} {{ member.lname }}</span>
											<div class="text-info">{{ member.email }}</div>
										</td>
										<td>{{ member.mobile }}</td>
										<td>{{ member.current_rank }}</td>
										<td>{{ member.follow_up_by }}</td>
										<td nowrap="">{{ member.date_follow_up }}</td>
										<td>{{ member.remarks }}</td>
										<td>{{ member.status }}</td>
									</tr>
									<tr v-if="followUp.data.length<=0">
										<td colspan="9">
											<p class="m-0 fw-bold h5 text-center text-danger">No Record Found</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<pagination :collections="followUp" />
					</div>
				</div>
			</div>
		</div>
	</div>
	<ExpiredFollowUp ref="followUpModal" />
</template>

<script>
import AuthLayout from '../../../Layouts/AuthLayout'
export default { layout: AuthLayout }
</script>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import { onMounted, watch, ref } from 'vue'
import ExpiredFollowUp from '../../../Components/Admin/ExpiredFollowUp'
import { createToaster } from '@meforma/vue-toaster';

onMounted(() => {
	const pageContainer = document.getElementById('page-container')
	if (pageContainer.classList.contains('sidebar-o-xs'))
		pageContainer.classList.remove('sidebar-o-xs')
})

const props = defineProps({
	expiredMembers 			: Object,
	// sevendayBeforeExpired 	: Object,
	filterby				: String,
	totalStatus				: Object,
	followUp 				: Object,
	api_response  			: Object
})

const toast = createToaster();

const followUpModal = ref(null);

const email_b 		= ref('');
const filterby 		= ref(props.filterby);
const email 		= ref('');
const date_start 	= ref('');
const date_end 		= ref('');

const f_date_start 		= ref('');
const f_date_end 		= ref('');
const followup_status 	= ref('');

const action = ref('');

const claimExpiredMember = ()=>{
	action.value = 'claim';
	Inertia.post(route('admin.transactions.post.expired-claim'), {}, {
				preserveState: true,
				preserveScroll: true,
				only: ['expiredMembers','followUp','totalStatus','api_response'],
				onSuccess: () => {}
			})
}

const searchRecord = (_is_reset) => {

	if(_is_reset==1)
	{
		email.value 		= "";
		date_start.value 	= "";
		date_end.value 		= "";
	}

	Inertia.get(
		route('admin.transactions.expired'),
		{
			email 		: email.value,
			filterby 	: filterby.value,
			date_start	: date_start.value,
			date_end 	: date_end.value
		},
		{
			preserveState: true,
			preserveScroll: true,
			only: ['filterby,totalStatus,expiredMembers']
		}
	)
}

const searchRecordBeforeExpired = (_is_reset) => {

	if(_is_reset==1)
	{
		email_b.value 		= "";
	}

	Inertia.get(
		route('admin.transactions.expired'),
		{
			email_b 		: email_b.value
		},
		{
			preserveState: true,
			preserveScroll: true,
			only: ['sevendayBeforeExpired']
		}
	)
}

const searchFollowUpRecord = (_is_reset) => {
	
	if(_is_reset==1)
	{
		f_date_start.value 		= "";
		f_date_end.value 		= "";
		followup_status.value 	= "";
	}

	Inertia.get(
		route('admin.transactions.expired'),
		{
			email 			: email.value,
			f_date_start	: f_date_start.value,
			f_date_end 		: f_date_end.value,
			followup_status : followup_status.value
		},
		{
			preserveState: true,
			preserveScroll: true,
			only: ['followUp']
		}
	)
}

const setMemberBefore = (index)=>{
	followUpModal.value.setMember(props.sevendayBeforeExpired.data[index]);
	followUpModal.value.toggleModal();
}

const setMember = (index)=>{
	action.value = 'followup';
	followUpModal.value.setMember(props.expiredMembers.data[index]);
	followUpModal.value.toggleModal();
}

watch(()=>props.api_response, (value) => {
			
	if(value!=null)
	{	
		if(value.result=="success")
		{	
			toast.show("Successfully saved", { type: value.result});
		}else
		{
			if(action.value=='claim')
			{
				toast.show("No more expired member to claim", { type: "error"});
			}else 
			{
				toast.show("Failed to save", { type: "error"});
			}
		}
	}
})

</script>
